import styled from "styled-components";
import { animated } from "@react-spring/web";

export const AnimButton = styled.button`
  transition: transform 0.25s cubic-bezier(0, 0, 0.2, 1.6);
  cursor: pointer;

  &:active {
    transform: scale(1.15);
  }
`;

export const reverseWobbly = { tension: 90, friction: 14, velocity: -0.01, mass: 2, clamp: true };

export const Center = styled(animated.div)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GreenBox = styled(Center)`
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: inset 0 0 14px 0 #0f0;
  border: solid 2px #0f0;
  background-color: #000;
  font-size: 1.125rem;
  font-weight: normal;
  line-height: 1;
  letter-spacing: 0.8px;
  text-align: center;
  text-wrap: nowrap;
  color: #0f0;

  @media (orientation: portrait) {
    border-radius: 12px;
    border-width: 4px; 
    font-size: 2.3rem;
  }
`;

export const Overlay = styled(animated.div)`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.75);
`;

export const MOBILE_WIDTH = '475px';

export const Header = styled.div`
  position: relative;
  filter: drop-shadow(0 0 5px #ff6900);
  background: linear-gradient(to bottom, #cf9b5e, #efe090) left clamp(0.125rem, -0.018rem + 0.488vh, 0.25rem) no-repeat, linear-gradient(#ffe893, #ffe893) left top no-repeat;
  font-family: Teko;
  font-size: clamp(2rem, 1.427rem + 1.951vh, 2.5rem);
  font-weight: 500;
  line-height: 0.85;
  letter-spacing: 1.42px;
  text-align: center;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (orientation: landscape){
    &:not(:last-child)::after {
      content: '\\0000a0';
    }
  }

  @media (orientation: portrait) {
    font-size: clamp(2.125rem, 1rem + 5vw, 3rem);
  }
`;
